import { render, staticRenderFns } from "./DnsViewManagement.vue?vue&type=template&id=5a2f9796&"
import script from "./DnsViewManagement.vue?vue&type=script&lang=js&"
export * from "./DnsViewManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports